import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setRooms: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 详情
export const setDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 光照配置
export const setEnvLight: Mutation<IModuleState> = (state, payload) => {
  state.envLight.data = payload.data;
  state.envLight.loading = !!payload.loading;
};

// 缩略图
export const setRoomThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = !!payload.loading;
};

// 失效样板间
export const setInvalidRooms: Mutation<IModuleState> = (state, payload) => {
  state.invalidRooms.data = payload.data;
  state.invalidRooms.loading = !!payload.loading;
};

// 清理日志
export const setClearLogs: Mutation<IModuleState> = (state, payload) => {
  state.clearLogs.data = payload.data;
  state.clearLogs.pageNum = payload.pageNum;
  state.clearLogs.pageSize = payload.pageSize;
  state.clearLogs.total = payload.total;
  state.clearLogs.loading = !!payload.loading;
};

// 定制物品
export const setSpecifics: Mutation<IModuleState> = (state, payload) => {
  state.specifics.data = payload.data;
  state.specifics.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

// 定制物品新增弹窗
export const setSpecificDialog: Mutation<IModuleState> = (state, payload) => {
  state.specificDialog.type = payload.type;
  state.specificDialog.visible = !!payload.visible;
  state.specificDialog.loading = !!payload.loading;
};

export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
